module.exports = __webpack_public_path__ + "static/media/cuadrado-bordes.9f3d0fd9.png";